import { useState } from 'react';

import { AxiosPublic } from '../utils/axios';
import { ResponseException } from '../models';
import { BlobServiceClient } from '@azure/storage-blob';

export const useUploadFTPForm = () => {
  const url = '/ftp-upload/authorize-upload';

  const [isFetching, setFetching] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [success, setSuccess] = useState<boolean>(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const upload = async (values, file: File, formRef) => {
    try {
      setSuccess(false);
      setFetching(true);
      setErrors([]);

      const response = await AxiosPublic.post(url, {
        fileName: file.name,
      });
      const { url: sasUrl, fileUrl, fileName } = response.data;
      const blobService = new BlobServiceClient(sasUrl);
      const containerClient = blobService.getContainerClient('ftp-uploads');

      const blockBlobClient = containerClient.getBlockBlobClient(response.data.fileName);
      await blockBlobClient.uploadBrowserData(file, {
        onProgress: ev => {
          setUploadProgress((ev.loadedBytes / file.size) * 100);
        },
      });

      const fileData = {
        ...values,
        mimetype: file.type,
        generatedUrl: fileUrl,
        encoding: 'UTF-8',
        filename: fileName,
        fileSize: file.size,
        originalname: file.name,
      };
      await AxiosPublic.post('/ftp-upload', fileData);
      setSuccess(true);
      formRef.current.resetForm();
      return response;
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    upload,
    errors,
    success,
    uploadProgress,
  };
};
